module.exports = "https://health.dajiuxing.com.cn/img/assets/serviceImg/service/Frame_4266@2x.png"


//////////////////
// WEBPACK FOOTER
// ./build/cdn-img-stub.js?path=assets%2FserviceImg%2Fservice%2FFrame_4266%402x.png
// module id = C0CJ
// module chunks = 93